<template>
	<transition name="fade">
		<div v-show="open" class="modal-popup" :class="{ active: open }">
			<div class="popup-overlay"></div>

			<div class="container">
				<div class="popup popup-may-scroll">
					<div class="popup-container popup-may-scroll">
						<div class="popup-form popup-may-scroll margin-top-30">
							<div class="form-container popup-may-scroll form-text-container no-border no-shadow">
								<div class="form-content popup-may-scroll text-left">
									<h4>Cos'è la success fee</h4>
									<p>
										Si tratta, in concreto, di una clausola in forza della quale il compenso degli avvocati viene pagato 
                    solo nel caso in cui il professionista riesca a raggiungere un risultato favorevole per il cliente. 
                    Pertanto il compenso, che a seconda dei casi e delle difficoltà può essere associato ad una minima 
                    componente fissa, è subordinato al vantaggio economico conseguito dal cliente e determinato in 
                    percentuale rispetto allo specifico risultato raggiunto.
									</p>                 
								</div>
							</div>
						</div>
					</div>

					<div class="close-btn" @click="preCloseModal">
						<i class="fa fa-close"></i>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import ModalHelper from '@/mixins/ModalHelper'

export default {
	name: 'SuccessFeeModal',
	mixins: [ModalHelper],
	mounted() {
		// Listen for open modal event
		this.$root.$on('open-success-fee-modal', () => {
			this.open = !this.open
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('open-success-fee-modal')
	},
	methods: {
		preCloseModal() {
			this.closeModal()
		},
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/utils/modals/misc/SuccessFeeModal.vue